<template>
  <div class="innerItem">
    <p class="innerTitle setLabel">{{locale.morningcall}}</p>
    <div class="mb15">
      <div class="checkbox mb5">
        <input type="checkbox" id="morningcall_active" v-model="morningcall.active">
        <label for="morningcall_active" class="label">{{ locale.activate }}</label>
      </div>
      <p class="sysMessage">{{locale.message_required_external_system}}</p>
    </div>
    <div v-if="morningcall.active">
      <div class="mb15">
        <div class="checkbox onoff">
          <input type="checkbox" id="morningcall_regist" v-model="morningcall.regist">
          <label for="morningcall_regist" class="label">{{morningcall.regist ? locale.regist_possible : locale.regist_not_possible}}</label>
        </div>
      </div>
      <div>
        <div class="label colorGrey mb5">{{locale.morningcall_repeat_settings}}</div>
        <p class="sysMessage">{{locale.message_set_morningcall_repeat}}</p>
        <div v-for="(item, index) in morningcall.repeat"
          :key="index"
          class="mb5">
          <div class="checkbox">
            <input type="checkbox" :id="`morningcall_repeat_${item.id}`" v-model="item.active" @click="checkRepeat($event, item.active)">
            <label :for="`morningcall_repeat_${item.id}`" class="label">{{locale[item.id]}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Morningcall',
  props: [
    'locale',
    'morningcall'
  ],
  computed: {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    checkRepeat (e, isActive) {
      const remainActive = this.morningcall.repeat.filter(x => x.active).length <= 1
      if (remainActive && isActive) {
        e.preventDefault()
      }
    }
  }
}
</script>
